import { Configuration, PopupRequest } from "@azure/msal-browser";

// MSAL configuration
const tenantId = process.env.REACT_APP_TENANT_ID;
const clientId = process.env.REACT_APP_APPLICATION_ID;

if (!tenantId || !clientId) {
  console.error(
    'MSAL Configuration Error: REACT_APP_TENANT_ID or REACT_APP_APPLICATION_ID is not defined! Please check your .env file and ensure it is loaded correctly.'
  );
}

export const msalConfig = {
  auth: {
    clientId: clientId || "0fe7cff3-8e09-4338-8d1a-ae3388772507", // Fallback to avoid crash, but log error
    authority: `https://login.microsoftonline.com/${tenantId || "266ee5f5-db91-4133-a62c-db7ade5302f3"}`, // Use tenantId from env
    redirectUri: `${window.location.origin}`, // Remove trailing slash for hash router compatibility
    postLogoutRedirectUri: `${window.location.origin}`,
    navigateToLoginRequestUrl: false, // Prevent MSAL from automatically navigating
    supportsNestedAppAuth: false, // Disable nested app auth to prevent hash issues
  },
  cache: {
    cacheLocation: "sessionStorage", // Or "localStorage" if you prefer
    storeAuthStateInCookie: true, // Enable for better cross-browser support
  },
  system: {
    loggerOptions: {
        loggerCallback: (level, message, containsPii) => {
            if (containsPii) {
                return;
            }
            switch (level) {
                case 0: // Error
                    console.error(message);
                    return;
                case 1: // Warning
                    console.warn(message);
                    return;
                case 2: // Info
                    console.info(message);
                    return;
                case 3: // Verbose
                    console.debug(message);
                    return;
                default:
                    return;
            }
        }
    }
}
};

// Add scopes for the ID token to be used at Microsoft Identity Platform endpoints.
// These scopes allow MSAL to request an ID token and access basic user profile info.
export const loginRequest = {
  scopes: ["User.Read", "openid", "profile", "email", "Directory.Read.All"], // Request basic profile info and email
};
